import { Grid } from '@mui/material';
import React from 'react'
import SelectInputBox from '../../../../../../constants/SelectInputBox';
import { VoucherContextType } from '../../../../../../context/VoucherEntryContext';
import { ParticularOptions } from '../../../../../../constants/Options';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import InputTextBox from '../../../../../../constants/InputTextBox';
import { BsPencil } from 'react-icons/bs';
interface HeaderFormViewProps {
    context: VoucherContextType;
}

const CashFormView: React.FC<HeaderFormViewProps> = ({ context }) => {
    const { values, setFieldValue, handleChange, handleBlur, touched, errors } = context;
    const handleSelectBox = (name: string, selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : null;
        setFieldValue(name, value);
    };
    const { AccountCashParticularList } = useSelector((state: RootState) => state.accounts);
    const cashParticularOptions = ParticularOptions(AccountCashParticularList);
    return (
        <Grid container>
            <Grid item lg={12} md={12} xs={12} xl={12} sm={12}>
                <SelectInputBox
                    label='Cash Type'
                    options={cashParticularOptions}
                    optionSelect={(name, selectedOption) => {
                        setFieldValue("part_is_debit", selectedOption.is_debit);
                        handleSelectBox(name, selectedOption);
                    }}
                    isLoading={false}
                    value={values.dep_particular_id}
                    required={true}
                    placeholder='Select voucher type'
                    name='dep_particular_id'
                    handleBlur={handleBlur}
                    touched={touched.dep_particular_id}
                    errors={errors.dep_particular_id}
                />
            </Grid>
            <Grid item lg={12} md={12} xs={12} xl={12} sm={12}>
                <InputTextBox
                    type='text'
                    prefix={<BsPencil />}
                    label='Remarks'
                    name='billingcomment'
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.billingcomment}
                    placeholder='Enter Remarks'
                    error={errors.billingcomment}
                    required={false}
                />
            </Grid>
        </Grid>
    )
}

export default CashFormView